import { useState } from 'react';
import { Box, Flex } from 'reflexbox';

import { LinkIcon } from '@treams/treams-icons';

import { Button } from '../Button';
import { Input } from '../Input';
import { Label, Paragraph } from '../Text';

export default function QuillLinkProperties(props: {
	initialValue?: string;
	onDismiss: (value?: string) => void;
}) {
	const [value, setValue] = useState(props.initialValue ?? '');

	return (
		<Box p={3} width={240}>
			<Paragraph>Link Address</Paragraph>
			<Label mb={3}>Enter the address that you would like this text to link to.</Label>
			<Input
				value={value}
				onChange={setValue}
				small
				icon={<LinkIcon />}
				placeholder="https://"
				autoFocus
				onKeyDown={(event) => {
					if (event.key === 'Enter') {
						props.onDismiss(value);
						event.preventDefault();
					}
				}}
			/>
			<Flex mt={3}>
				{props.initialValue ? (
					<Box mr={2}>
						<Button title="Remove" type="destructive" small onClick={() => props.onDismiss('')} />
					</Box>
				) : (
					<Box mr={2}>
						<Button title="Cancel" type="secondary" small onClick={() => props.onDismiss()} />
					</Box>
				)}
				<Box flexGrow={1} />
				<Box>
					<Button title="Done" small onClick={() => props.onDismiss(value)} />
				</Box>
			</Flex>
		</Box>
	);
}
